// Created By Issyah Ismail
/**
 * A custom HTML element for datepicker*/
class DatePicker extends HTMLElement {
  constructor() {
    super();
    this.init();
    // this.initTime();
    const selectTime = this.querySelector('#delivery-time');
    selectTime.addEventListener('change', this.onChangeTime.bind(this));
  }

  init() {
    const input = this.querySelector('#delivery-date');
    const selectTime = this.querySelector('#delivery-time');
    // set 3 months in advance only
    const maxDate = moment().add(90, 'd').format();
    let minDate = moment();
    // disable same day delivery if they are viewing after 2pm.
    const cutoffTime = moment().set({ hours: 14, minutes: 0 });
    if (moment().isAfter(cutoffTime)) {
      minDate = moment().add(1, 'd');
    }
    new AirDatepicker(input, {
      minDate,
      maxDate,
      onSelect: ({ date, formattedDate, datepicker }) => {
        if (formattedDate) {
          // Selected today's date
          if (moment(date).isSame(new Date(), 'day')) {
            this.updateTimingWindow('sameDayTimingWindow');
          } else {
            this.updateTimingWindow('defaultTimingWindow');
          }
          // update API
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Delivery Date': formattedDate,
                'Delivery Time': selectTime.value,
              },
            }),
          });
        }
      },
      dateFormat: 'dd/MM/yy',
    });
  }
  /**
   * check if date has already been set on init, then populate the
   * time range
   */
  initTime() {
    const deliveryDate = this.querySelector('#delivery-date');
    // a date has been set by previous saved state, update the timing window
    if (deliveryDate.value) {
      const cutoffTime = moment().set({ hours: 14, minutes: 0 });
      console.log(deliveryDate.value);
      const currentSavedDate = moment(deliveryDate.value, 'DD/MM/YY');
      // update time based on logic
      if (currentSavedDate.isSame(moment())) {
        this.updateTimingWindow('sameDayTimingWindow', true);
      } else {
        this.updateTimingWindow('defaultTimingWindow', true);
      }
    }
  }
  /**
   * If the user selects today's date and it is before 2pm, the timing window
   * will be changed to from 3pm - 7pm. This is because we need time to
   * prepare same-day delivery*/
  updateTimingWindow(type, defaultSelect = true) {
    const sameDayTimingWindow = [
      {
        value: '3:00pm - 8:00pm',
        label: '3pm - 8pm',
      },
    ];
    const defaultTimingWindow = [
      {
        value: '12:00pm - 3:00pm',
        label: '12pm - 3pm',
      },
      {
        value: '3:00pm - 6:00pm',
        label: '3pm - 6pm',
      },
      {
        value: '6:00pm - 9:00pm',
        label: '6pm - 9pm',
      },
    ];
    const timingWindow = {
      sameDayTimingWindow,
      defaultTimingWindow,
    };
    const select = this.querySelector('#delivery-time');
    const newTimingWindow = timingWindow[type];
    if (newTimingWindow) {
      // TODO: need to consider the current time now
      select.innerHTML = '';
      newTimingWindow.forEach((item, index) => {
        const option = document.createElement('option');
        // if (defaultSelect && index == 0) {
        //   option.setAttribute('selected', true);
        // }
        option.value = item.value;
        option.innerHTML = item.label;
        select.append(option);
      });
    }
  }
  onChangeTime(e) {
    const value = e.target.value;
    if (!value) {
      return;
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'Delivery Time': value,
        },
      }),
    });
  }
}

customElements.define('delivery-datepicker', DatePicker);
